import React from 'react'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { CORAL_600, GRAY_700, GRAY_900 } from 'constants/styling/theme'

interface Props {
  email: string
  /** Known only for a client picked in this drawer instance; the store does not keep it. */
  workspaceName?: string
  onChange: () => void
}

/** "Ordering for <client>" above an admin's property search, with the way back to the client picker. */
export const AdminTargetBanner: React.FC<Props> = ({ email, workspaceName, onChange }) => {
  const { t } = useTranslation(['purchase_flow_revamp'])

  return (
    <Stack direction="row" alignItems="center" gap={0.6} flexWrap="wrap" mb="1.2rem" data-cy="pf-revamp-admin-target-banner">

      <Typography variant="text-sm" color={GRAY_700}>
        {t('purchase_flow_revamp:admin_gate.ordering_for_label')}
      </Typography>

      <Typography variant="text-sm" color={GRAY_900} fontWeight={500}>
        {workspaceName ? `${email} · ${workspaceName}` : email}
      </Typography>

      <Typography
        variant="text-sm"
        color={GRAY_900}
        fontWeight="bold"
        sx={{ cursor: 'pointer', '&:hover': { color: CORAL_600 } }}
        onClick={onChange}
        data-cy="pf-revamp-admin-target-change"
      >
        {t('purchase_flow_revamp:admin_gate.change_client')}
      </Typography>

    </Stack>
  )
}
